module.exports = __webpack_public_path__ + "img/4f_r_jindaiji@2x.d6757e83.png";